"use strict";
// Copyright (c) StrangeBee 2024
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
class PageController extends __1.ParentController {
    constructor() {
        super(...arguments);
        this.endpoints = {
            create: '/v1/page',
            edit: '/v1/page/:objectId',
            delete: '/v1/page/:objectId',
        };
    }
}
exports.default = PageController;
